// extracted by mini-css-extract-plugin
export default {"main":"advicepage_main__-wt41"};